export default "__VITE_ASSET__B2pebr_K__"